
import { Component, Prop, Vue } from "vue-property-decorator";
import { StreamConfigInterface } from "./stream.types";
import { INASAStreams } from "../../store-services/staticdata.types";

const REPLACER_DEFAULTS: { [key: string]: boolean|number } = {
  autoplay: true,
  mute: true,
  controls: true
};

const PARAM_MAP: {[key: string]: boolean|string} = {
  "0": false,
  "1": true,
  "true": "1",
  "false": "0"
}

// const USTREAM_BASE = "https://www.ustream.tv/embed/{streamid}?autoplay={autoplay}&controls={controls}&showtitle={showtitle}&volume={volume}";
const YOUTUBE_BASE = "https://www.youtube-nocookie.com/embed/{streamid}?autoplay={autoplay}&controls={controls}&mute={mute}";

type StreamStateResult = "" | "warning" | "error"
interface StreamState {
  state: "loading" | "loaded",
  result: StreamStateResult,
  text: string
}

@Component
export default class StreamComponent extends Vue {
  @Prop() config!: StreamConfigInterface;
  frameState: "loading" | "loaded" | "error" = "loading"
  get streamState(): StreamState {
    let state = null
    let result = '' as StreamStateResult
    let text = ""
    if (this.streams.content?.hasOwnProperty("error") && this.streams.content?.error) {
      result = "warning"
      text = this.streams.content?.error.short
    }
    if (this.streamBackendStatus === "error") {
      result = "error"
      text = "Backend loading failed."
    }
    if (this.streamBackendStatus === "ok" && this.streamid == null) {
      state = "loaded" as StreamState["state"]
    }
    if (this.frameState === "error") {
      result = "error"
      text = "Failed to load stream frame."
    }
    return {
      state: state || (this.frameState === "loading" ? "loading" : "loaded"),
      result,
      text
    }
  }

  constructor() {
    super();
  }

  mounted() {
    this.$store.dispatch("staticdata/updateStreams");
  }

  get streams(): INASAStreams {
    return this.$store.getters["staticdata/getStreams"];
  }
  get streamBackendStatus() {
    return this.streams.status
  }

  get streamid() {
    return this.streams.content
      && this.streams.content.data.hasOwnProperty(this.config.streamid) ? this.streams.content.data[this.config.streamid].id : null;
  }

  get url() {
    let url = "";
    if (this.streamid) {
      let config = {...this.config, streamid: this.streamid};
      url = YOUTUBE_BASE;
      let replKeys = YOUTUBE_BASE.matchAll(/\{([^\}]*)\}/g);

      let repl;
      while (repl = replKeys.next()) {
        if (repl.done) break;
        const replKey: string = repl.value[1];
        let replValue: any = Object.keys(config).indexOf(replKey) !== -1
          ? (config as { [key: string]: any })[replKey]
          : REPLACER_DEFAULTS.hasOwnProperty(replKey)
          ? REPLACER_DEFAULTS[replKey]
          : "";

        replValue = replValue.toString();
        switch(replKey) {
          case "mute":
          case "controls":
          case "autoplay":
            replValue = PARAM_MAP[replValue];
            break;
          default:
            break;
        } 

        url = url.replace(repl.value[0], replValue);
      }
    }
    return url;
  }
}
